import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { apiGetSubscriptionSelf } from "../actions/get-my-subscriptions.actions";
import {
    FlowMobileSubscriptionSelfResponse,
    SubscriptionSection,
} from "../interfaces/subscriptions.interfaces";
import { SUBSCRIPTION_KEYS } from "../queries/subscription.queries";

export const useSubscriptionInfoQuery = (
    {
        skipPayPalFetch,
        section,
    }: {
        skipPayPalFetch: boolean;
        section: SubscriptionSection;
    }
): UseQueryResult<FlowMobileSubscriptionSelfResponse, Error> => {
    return useQuery<FlowMobileSubscriptionSelfResponse, Error>({
        queryKey: SUBSCRIPTION_KEYS.self(section),
        queryFn: () => apiGetSubscriptionSelf({ section, skipPayPalFetch }),
        enabled: Boolean(section),
    });
};